import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

function ensureClientTrace() {
  try {
    let t = sessionStorage.getItem("hr_pricing_audit_trace");
    if (!t) {
      t =
        typeof crypto !== "undefined" && crypto.randomUUID
          ? crypto.randomUUID()
          : `t-${Date.now()}`;
      sessionStorage.setItem("hr_pricing_audit_trace", t);
    }
    return t;
  } catch {
    return `t-${Date.now()}`;
  }
}

/**
 * Unified FE → POST /api/admin/pricing-audit/ingest
 * Requires VITE_PRICING_AUDIT_INGEST_KEY or VITE_ADMIN_API_KEY in build.
 * Set VITE_PRICING_AUDIT_FRONTEND=0 to disable all calls.
 *
 * @param {object} payload — must include page_key, final_price_displayed; entity_id recommended.
 */
export function sendPricingAuditEvent(payload) {
  try {
    if (typeof import.meta !== "undefined" && import.meta.env?.VITE_PRICING_AUDIT_FRONTEND === "0") {
      return;
    }
    const ingest = (import.meta.env?.VITE_PRICING_AUDIT_INGEST_KEY || "").trim();
    const admin = (import.meta.env?.VITE_ADMIN_API_KEY || "").trim();
    const headers = { "Content-Type": "application/json", Accept: "application/json" };
    if (ingest) {
      headers["X-Pricing-Audit-Ingest-Key"] = ingest;
    } else if (admin) {
      headers["X-Admin-Api-Key"] = admin;
    } else {
      return;
    }

    const base = ensureClientTrace();
    const eid = payload.entity_id != null ? String(payload.entity_id) : "";
    const calc_trace_id =
      payload.calc_trace_id ||
      (eid ? `${base}::${payload.entity_type || "e"}::${eid}` : base);

    const body = {
      event_type: "PRICE_RENDERED",
      currency: "ILS",
      pricing_source: "fe_ingest",
      ...payload,
      calc_trace_id: String(calc_trace_id).slice(0, 80),
    };

    axios
      .post(resolveApiUrl("/api/admin/pricing-audit/ingest"), body, {
        headers,
        withCredentials: true,
        timeout: 8000,
      })
      .catch(() => {});
  } catch {
    /* never break UI */
  }
}
